const en = {
  a11yVideoLabelText: "Video showing face liveness check",
  cameraMinSpecificationsHeadingText: "Minimum Camera Specifications",
  cameraMinSpecificationsMessageText:
    "Please ensure your camera meets the minimum specifications required for the liveness check.",
  cameraNotFoundHeadingText: "Camera Not Found",
  cameraNotFoundMessageText:
    "We couldn't detect a camera. Please ensure your camera is connected and try again.",
  cancelLivenessCheckText: "Cancel Liveness Check",
  clientHeaderText: "Client Message",
  clientMessageText:
    "Please follow the instructions on the screen to complete the face liveness check.",
  connectionTimeoutHeaderText: "Connection Timeout",
  connectionTimeoutMessageText:
    "The connection timed out. Please check your internet connection and try again.",
  errorLabelText: "Error",
  faceDistanceHeaderText: "Face Distance",
  faceDistanceMessageText:
    "Please ensure your face is within the correct distance from the camera.",
  goodFitAltText: "Face is well aligned",
  goodFitCaptionText: "Your face is well aligned. Please hold still.",
  hintCanNotIdentifyText: "Cannot identify face. Please try again.",
  hintCenterFaceInstructionText: "Center your face in the frame.",
  hintCenterFaceText: "Center your face",
  hintCheckCompleteText: "Check complete",
  hintConnectingText: "Connecting...",
  hintFaceDetectedText: "Face detected",
  hintFaceOffCenterText: "Your face is off-center. Please adjust.",
  hintHoldFaceForFreshnessText: "Hold your face still for the check.",
  hintIlluminationNormalText: "Lighting is good",
  hintIlluminationTooBrightText: "Lighting is too bright",
  hintIlluminationTooDarkText: "Lighting is too dark",
  hintMatchIndicatorText: "Matching face indicators...",
  hintMoveFaceFrontOfCameraText: "Move your face in front of the camera",
  hintTooCloseText: "You are too close to the camera",
  hintTooFarText: "You are too far from the camera",
  hintTooManyFacesText:
    "Too many faces detected. Only one face should be in the frame.",
  hintVerifyingText: "Verifying...",
  landscapeHeaderText: "Landscape Mode Detected",
  landscapeMessageText:
    "Please switch to portrait mode for the liveness check.",
  multipleFacesHeaderText: "Multiple Faces Detected",
  multipleFacesMessageText:
    "Only one face should be in the frame. Please adjust and try again.",
  photosensitivityWarningBodyText:
    "This check involves a series of visual stimuli. If you have photosensitivity issues, please proceed with caution.",
  photosensitivityWarningHeadingText: "Photosensitivity Warning",
  photosensitivityWarningInfoText:
    "You can stop the check at any time if you feel discomfort.",
  photosensitivityWarningLabelText: "I understand the risks",
  portraitMessageText: "Please hold your device in portrait mode.",
  recordingIndicatorText: "Recording in progress",
  retryCameraPermissionsText: "Retry Camera Permissions",
  serverHeaderText: "Server Issue",
  serverMessageText:
    "There was a problem connecting to the server. Please try again later.",
  startScreenBeginCheckText: "Begin Liveness Check",
  timeoutHeaderText: "Timeout",
  timeoutMessageText: "The process timed out. Please try again.",
  tooFarAltText: "Face is too far from the camera",
  tooFarCaptionText: "Please move closer to the camera.",
  tryAgainText: "Try Again",
  waitingCameraPermissionText: "Waiting for camera permission...",
};
export default en;
